import {Button, IconButton, Snackbar as MuiSnackbar, SnackbarContent} from '@material-ui/core';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {CheckCircle, Close, Error, Warning} from '@mui/icons-material';
import clsx from 'clsx';
import React from 'react';

const variantIcon: any = {
  success: CheckCircle,
  warning: Warning,
  error: Error,
};

const snackbarContentStyles = makeStyles((theme: Theme) => ({
  success: {backgroundColor: '#32BDC7'},
  error: {backgroundColor: theme.palette.error.dark},
  info: {backgroundColor: '#e6f1f2', color: '#4a4a4a'},
  warning: {backgroundColor: '#FFBC49'},
  icon: {fontSize: 20},
  iconVariant: {opacity: 0.9, marginRight: theme.spacing(1)},
  message: {display: 'flex', alignItems: 'center', whiteSpace: 'pre-line'},
  button: {color: '#fff', fontSize: 13, fontWeight: 500, marginRight: -8},
}));

const snackbarStyles = makeStyles((theme: Theme) => ({
  margin: {margin: theme.spacing(1)},
}));

const LegacySnackbarContent = (props: any) => {
  const classes: any = snackbarContentStyles();
  const {className, message, onAction, variant, actionTitle, onClose, noClose, ...other} = props;
  const Icon = variantIcon[variant];
  const action: React.ReactNode[] = [];

  if (onAction) {
    action.push(
      <Button
        key="action"
        color="primary"
        size="small"
        className={classes.button}
        onClick={() => {
          onAction();
          onClose();
        }}>
        {actionTitle}
      </Button>,
    );
  }

  if (!noClose && onClose) {
    action.push(
      <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
        <Close className={classes.icon} />
      </IconButton>,
    );
  }

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          {Icon ? <Icon className={clsx(classes.icon, classes.iconVariant)} /> : null}
          {message}
        </span>
      }
      action={action}
      {...other}
    />
  );
};

const LegacySnackbar = (props: any) => {
  const classes = snackbarStyles();
  const {className, message, isOpen, variant, actionTitle, onAction, onClose, noClose, ...other} = props;

  return (
    <MuiSnackbar
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
      open={isOpen}
      autoHideDuration={1000}
      {...other}>
      <LegacySnackbarContent
        variant={variant || 'error'}
        className={classes.margin}
        message={message}
        onAction={onAction}
        actionTitle={actionTitle}
        noClose={noClose}
        onClose={onClose}
      />
    </MuiSnackbar>
  );
};

export default LegacySnackbar;
